function Contact() {
  return (
    <div className="contact-page">

      {/* ================= HERO ================= */}
      <section className="contact-hero">
        <div className="contact-hero-overlay">
          <h1>
            Contact AGP India Organic
          </h1>

          <p>
            Fresh organic fruits and vegetables
            directly from farms to your home.
          </p>
        </div>
      </section>


      {/* ================= CONTACT SECTION ================= */}
      <section className="contact-wrapper">

        <div className="contact-left">

          <h2>Get In Touch</h2>

          <p className="contact-description">
            Have questions about our organic
            products, delivery services, bulk
            orders, or business enquiries?
            Contact us anytime.
          </p>


          {/* ================= REGISTERED OFFICE ================= */}
          <div className="contact-card">

            <div className="contact-icon">
              🏢
            </div>

            <div>
              <h3>Registered Office</h3>

              <p>
                AGP India Organic<br />
                E-33, Flat No-06 Devli Road, Khanpur<br />
                Exten, Devli Deoli South<br />
                Delhi - 110062
              </p>
            </div>

          </div>


          {/* ================= BRANCH OFFICE ================= */}
          <div className="contact-card">

            <div className="contact-icon">
              🏢
            </div>

            <div>
              <h3>Branch Office</h3>

              <p>
                AGP India Organic<br />
                C-177, SECTOR-10, NOIDA<br />
                NOIDA CITY ZONE-1<br />
                GAUTAM BUDDHA NAGAR, UTTAR PRADESH - 201301
                GENERAL MANUFACTURING , WHOLESALER OR RETAILER
              </p>
            </div>

          </div>


          {/* ================= WAREHOUSE ================= */}
          <div className="contact-card">

            <div className="contact-icon">
              🏭
            </div>

            <div>
              <h3>Warehouse</h3>

              <p>
                AGP India Organic<br />
                11-3, B-Block Rd,<br />
                Avantika, Sector-1,<br />
                Rohini, New Delhi - 110085
              </p>
            </div>

          </div>


          {/* ================= PHONE ================= */}
          <div className="contact-card">

            <div className="contact-icon">
              📞
            </div>

            <div>
              <h3>Call Us</h3>

              <p>
                +91 8826121677
              </p>

              <p>
                +91 8882006037
              </p>

              <p>
                +91 9540264410
              </p>

              <p>
                +91 8750551796
              </p>
            </div>

          </div>


          {/* ================= EMAIL ================= */}
          <div className="contact-card">

            <div className="contact-icon">
              ✉
            </div>

            <div>
              <h3>Email Address</h3>

              <p>
                agpindiaorganic@gmail.com
              </p>
            </div>

          </div>

        </div>


        {/* ================= WHATSAPP ================= */}
        <div className="contact-right">

          <div className="whatsapp-box">

            <div className="whatsapp-icon">
              💬
            </div>

            <h2>
              Chat With Us On WhatsApp
            </h2>

            <p>
              Have questions about fresh organic
              fruits, vegetables, delivery, or bulk
              orders? Contact us instantly on
              WhatsApp.
            </p>

            <a
              href="https://wa.me/918826121677?text=Hello%20AGP%20India%20Organic,%20I%20want%20to%20know%20more%20about%20your%20organic%20products."
              target="_blank"
              rel="noreferrer"
              className="whatsapp-btn"
            >
              Chat on WhatsApp
            </a>

            <div className="whatsapp-extra">

              <div className="extra-item">
                ✅ Fast Reply
              </div>

              <div className="extra-item">
                🚚 Delivery Support
              </div>

              <div className="extra-item">
                🥬 Organic Product Help
              </div>

            </div>

          </div>

        </div>

      </section>


      {/* ================= MAP ================= */}
      <section className="modern-map-section">

        <h2 className="map-heading">
          Visit Our Registered Office
        </h2>

        <p className="map-subheading">
          Find AGP India Organic on Google Maps
          and visit our registered office in
          Rohini, New Delhi.
        </p>

        <div className="modern-map">

          <iframe
            title="AGP India Organic Registered Office Location"
            src="https://www.google.com/maps?q=11-3,B-Block+Rd,+Block+B,+Avantika,+Sector-1,+Rohini,+New+Delhi+110085&output=embed"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>

        </div>

      </section>

    </div>
  );
}

export default Contact;